import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import IconWarning from 'components/icons/IconWarning';

const styles = theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    padding: 15,
    borderRadius: 4,
    '& + &': {
      marginTop: 16,
    },
  },
  rootVariantError: {
    color: theme.palette.validation[500],
    backgroundColor: theme.palette.validation[100],
    border: `1px solid ${theme.palette.validation[500]}`,
  },
  rootVariantWarning: {
    color: theme.palette.notification[900],
    backgroundColor: theme.palette.notification[50],
    border: `1px solid ${theme.palette.notification[900]}`,
  },
  iconWarning: {
    width: 24,
    height: 21,
    marginRight: 25,
  },
});

const FormError = ({ children, className, variant, classes }) => (
  <div
    className={classNames(classes.root, className, {
      [classes.rootVariantError]: variant === 'error',
      [classes.rootVariantWarning]: variant === 'warning',
    })}
    name="_error"
  >
    <IconWarning className={classes.iconWarning} />
    <Typography
      variant="subheading"
      color="inherit"
    >
      {children}
    </Typography>
  </div>
);

FormError.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['error', 'warning']),
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    rootVariantError: PropTypes.string.isRequired,
    rootVariantWarning: PropTypes.string.isRequired,
    iconWarning: PropTypes.string.isRequired,
  }).isRequired,
};

FormError.defaultProps = {
  className: '',
  variant: 'error',
};

export default withStyles(styles)(FormError);



// WEBPACK FOOTER //
// ./src/components/common/FormError.js